import React, { useState, useEffect } from "react";
import './NavBar.css';
import logoPNG from './logo.png'

const NavBar = () => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [ username, setUsername ] = useState("");
   
    useEffect(() => {
        // Get username from sessionStorage
        setUsername(sessionStorage.getItem('username') || "");
    }, []);
    const initial = username ? username[0].toUpperCase() : "?";

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <a href="/" className="logo">
                    <img src={logoPNG} alt="NextDriv-logo"></img>
                </a>
            </div>
            <div className="navbar-right">
                <ul className="nav-links">
                    <li><a href="/home" className="nav-link">Home</a></li>
                    <li><a href="/comparative-analysis" className="nav-link">Analysis</a></li>
                    <li><a href="/" className="nav-link">Logout</a></li>
                </ul>
                <div className="user-initial-container" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    <div className="user-initial">
                        {initial || "?"}
                    </div>
                    {dropdownOpen && (
                        <div className="dropdown-menu">
                            <a href="/account">Account</a>
                            <a href="/config-settings">Configuration Settings</a>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default NavBar;